import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';

export const BenefitsCardBox = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  flex: '1 0 0',
  padding: '0px',
});

export const LinkContainer = styled('div', {
  display: 'flex',
  margin: '4px 0',
  zIndex: '2',
  '@media (max-width: 464px)': {
    marginBottom: '0px',
  },
});

export const IconContainer = styled('div', {
  position: 'relative',
  variants: {
    isGeha: {
      true: {
        right: '12px',
      },
      false: {
        right: '4px',
      },
    },
  },
});

export const slideContainerStyle = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  'abyss-slide-container': {
    display: 'flex',
    flex: '0 0 100%',
    height: '100%',
  },
  'abyss-slide-card': {
    padding: '0',
    visibility: 'visible',
    border: 'none',
    height: '100%',
    '> div': {
      height: '100%',
    },
  },
};

export const carouselStyle = {
  'abyss-carousel-root': {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    '@media (min-width: 465px)': {
      width: '100%',
      marginTop: '16px',
    },
    '@media (max-width: 464px)': {
      width: '100%',
      marginTop: '12px',
    },
    '.abyss-carousel-heading': {
      display: 'none',
    },
    '.abyss-carousel-controls': {
      marginTop: '0px',
      padding: '0px',
      height: '20px',
      marginBottom: '20px',
      maxWidth: '100%',
      '@media (max-width: 464px)': {
        marginBottom: 0,
      },
    },
    '.abyss-carousel-pagination-container': {
      overflowX: 'auto',
    },
    '.abyss-carousel-swiper-container': {
      display: 'flex',
      marginBottom: '12px',
      width: '100%',
      willChange: 'transform',
      zIndex: 0,
    },
    '.abyss-carousel-slide-container': {
      position: 'relative',
      width: '384px',
      gap: '24px',
      height: 'auto',
      '@media (max-width: 464px)': {
        width: '311px',
        gap: '24px',
      },
    },

    '.abyss-carousel-nav-container-right': {
      width: '20px',
      height: '20px',
      padding: '0px',
    },
    '.abyss-carousel-nav-container-left': {
      width: '20px',
      height: '20px',
      padding: '0px',
    },
  },
};

export const GridColStyle = {
  padding: '12px 12px 0 12px',
  '@media (max-width: 464px)': {
    padding: '0px',
  },
};
